// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3H9vn","filesListContainer":"PosDisputesFiles_filesListContainer__9KMe3","filesButton":"PosDisputesFiles_filesButton__1RXE5"};